module.exports = __webpack_public_path__ + "img/newsletter.da87a534.svg";